import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { AppStateService } from '../services/app-state.service';
import { LocalStorageService } from '../services/storage/local-storage.service';
import { StateService } from '../services/storage/state.service';
import { Profile } from '../models/profile.mode';

@Injectable({
  providedIn: 'root'
})
export class ClubMemberGuard implements CanActivate {
  private readonly localStorageService = inject(LocalStorageService);
  private readonly appStateService = inject(AppStateService);
  private readonly stateService = inject(StateService);
  private readonly router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (!this.localStorageService.isLoggedIn) {
      return true;
    }
    const profile = this.resolveProfile();
    if (profile?.is_club_member) {
      return this.router.createUrlTree(['/kingclub/club-levels']);
    }

    return true;
  }

  private resolveProfile(): Profile | null {
    const appStateProfile = this.appStateService.getProfile();
    if (appStateProfile) {
      return appStateProfile;
    }

    return this.stateService.userProfile();
  }
}
